import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { deleteContactpersoonForEntity } from '../services/deleteContactpersoonForEntity'

import { queryKey as queryKeyContactpersonen } from './useContactpersonenForEntity'

export { useDeleteContactpersoonForEntity }

const useDeleteContactpersoonForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: deleteContactpersoonForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyContactpersonen] })
      successAlert('Contactpersoon verwijderd')
    },
  })
}
